import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CampaignMediaVariationsState} from './campaignMediaVariations.types';

const campaignMediaVariationsInitialState: CampaignMediaVariationsState = {
  variationsCount: null,
  renderJobId: null,
  isCountingVariations: false,
  scheduleData: null,
  mediaVariationsIssues: [],
  mediaStatus: null,
  wasRenderExecuted: false,
};

const campaignMediaVariationsSlice = createSlice({
  name: 'campaignMediaVariations',
  initialState: campaignMediaVariationsInitialState,
  reducers: {
    resetCampaignMediaVariations: () => campaignMediaVariationsInitialState,
    updateCampaignMediaVariations: (
      state,
      action: PayloadAction<Partial<CampaignMediaVariationsState>>,
    ) => {
      return {...state, ...action.payload};
    },
  },
});

const {resetCampaignMediaVariations, updateCampaignMediaVariations} =
  campaignMediaVariationsSlice.actions;

export {resetCampaignMediaVariations, updateCampaignMediaVariations};

export default campaignMediaVariationsSlice.reducer;
